import './bootstrap';
import 'alpinejs';
import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/brands.scss';
import '@fortawesome/fontawesome-free/scss/regular.scss';
import '@fortawesome/fontawesome-free/scss/solid.scss';
import '@fortawesome/fontawesome-free/scss/v4-shims.scss';

import $ from 'jquery';

window.$ = window.jQuery = $;

import '../ts/notifications.ts';
import './livewire-snapshot-fix.js';
